import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { Zaikbn } from "@/models/enum/Enum";

type Props = {
  value: Zaikbn;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ZaikbnChip',
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as {
  value: Zaikbn;
};



const items = [
  { text: "在籍", value: Zaikbn.ZAI, color: "success" },
  { text: "退職", value: Zaikbn.TAI, color: "warning" },
  { text: "休職", value: Zaikbn.KYU, color: "" }
] as const;

const item = computed(() => items.find(e => e.value === props.value));

return { __sfc: true,props, items, item }
}

})